var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUserDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33317 2.70801C6.37716 2.70801 4.7915 4.29367 4.7915 6.24967C4.7915 8.20568 6.37716 9.79134 8.33317 9.79134C10.2892 9.79134 11.8748 8.20568 11.8748 6.24967C11.8748 4.29367 10.2892 2.70801 8.33317 2.70801ZM6.0415 6.24967C6.0415 4.98402 7.06752 3.95801 8.33317 3.95801C9.59884 3.95801 10.6248 4.98402 10.6248 6.24967C10.6248 7.51532 9.59884 8.54134 8.33317 8.54134C7.06752 8.54134 6.0415 7.51532 6.0415 6.24967Z",
    fill: "#201E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 14.167C3.125 13.1315 3.96447 12.292 5 12.292H5.28406C5.30602 12.292 5.32785 12.2955 5.34872 12.3022L6.06998 12.5378C6.90038 12.8089 7.76732 12.927 8.6295 12.8919C8.7445 12.8872 8.83858 12.8015 8.86283 12.689C8.92408 12.4057 9.00942 12.1312 9.11642 11.868C9.16692 11.7437 9.06442 11.6051 8.93092 11.6183C8.10156 11.7007 7.25924 11.6112 6.45799 11.3496L5.73672 11.114C5.59057 11.0663 5.4378 11.042 5.28406 11.042H5C3.27411 11.042 1.875 12.4411 1.875 14.167V15.1572C1.875 15.7849 2.3299 16.3201 2.94939 16.4212C5.11208 16.7743 7.30083 16.9132 9.484 16.8381C9.61942 16.8334 9.69275 16.6762 9.61642 16.5643C9.45483 16.3274 9.31308 16.0758 9.1935 15.8121C9.136 15.6851 9.01025 15.6011 8.87083 15.6034C6.95868 15.6353 5.04437 15.4967 3.15081 15.1876C3.13593 15.1852 3.125 15.1723 3.125 15.1572V14.167Z",
    fill: "#201E2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.75C10 14.5599 10.2567 15.3098 10.6932 15.9228C10.9365 16.2644 11.2356 16.5635 11.5772 16.8068C12.1902 17.2433 12.9401 17.5 13.75 17.5C15.8211 17.5 17.5 15.8211 17.5 13.75C17.5 12.9401 17.2433 12.1902 16.8068 11.5772C16.5635 11.2356 16.2644 10.9365 15.9228 10.6932C15.3098 10.2567 14.5599 10 13.75 10C11.6789 10 10 11.6789 10 13.75ZM13.75 16.25C13.2863 16.25 12.8522 16.1238 12.48 15.9038L15.9038 12.48C16.1238 12.8522 16.25 13.2863 16.25 13.75C16.25 15.1307 15.1307 16.25 13.75 16.25ZM11.5962 15.02L15.02 11.5962C14.6477 11.3762 14.2137 11.25 13.75 11.25C12.3692 11.25 11.25 12.3692 11.25 13.75C11.25 14.2137 11.3762 14.6477 11.5962 15.02Z",
    fill: "#201E2A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserDisable);
export default __webpack_public_path__ + "static/media/icon_userDisable.ee61aea4a2b36bf34da9dac6234fb1ea.svg";
export { ForwardRef as ReactComponent };